import React, { useContext, useState } from "react";
import { Grid, FormControl, Button, TextField, } from "@mui/material";
import { useForm } from "react-hook-form";
import MultiSelectInput from "../MultiSelect/MultiSelect";
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import AuthContext from "../../context/AuthContext";
import ButtonTheme from "../ThemeButton/ThemeButton";
import { toast } from 'react-toastify';

export default function CustomGroupForm({ array }) {
    const {
        register,
        formState: { errors },
        handleSubmit,
        setError,
    } = useForm();
    const [loading, setLoading] = useState(false);
    // const { enqueueSnackbar } = useSnackbar();
    const { pagesName } = useContext(AuthContext);

    const onFormSubmission = async (d, event) => {
        let data = {
            name: d.name,
        };
        let values = [];
        d.employees.map((item) => {
            values.push(item.value);
        });
        data = { ...data, employees: values };
        ApiService.post("/custom-group", data)
            .then((data) => {
                toast.success(data.message)
                // enqueueSnackbar("success", { variant: "success" });
            })
            .catch(({ data }) => {
                toast.error(data.message)
                // enqueueSnackbar("Error", { variant: "error" });
                setError("message", { type: "manual", message: data.message });
            });
    };

    return (
        <form>
            <Grid container spacing={0}>
                <>
                    <Grid xs={12} md={4} sm={12} sx={{ paddingRight: '20px', marginTop: '4px' }}>
                        <FormControl required={true} fullWidth>
                            <label>Name</label>
                            <TextField
                                {...register("name")}
                                inputProps={{ type: "string" }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid xs={12} md={8} sm={12}>
                        <FormControl required={true} fullWidth>
                            <label>Employee</label>
                            <MultiSelectInput
                                inputName="employees"
                                array={array}
                                register={register}
                                required={true}
                            />
                        </FormControl>
                    </Grid>

                    <Grid size={12} style={{ marginTop: '16px' }}>
                        <ButtonTheme
                            color="primary"
                            disabled={loading}
                            onClick={() => {
                                handleSubmit((data, event) =>
                                    onFormSubmission(data, event)
                                )();
                            }}
                        >
                            {"Add " + Object.keys(pagesName).includes("GROUP_HEADER_TEXT")
                                ? pagesName.GROUP_HEADER_TEXT
                                : "Group"
                            }
                        </ButtonTheme>
                    </Grid>
                </>
            </Grid>
        </form>
    );
}
